import {
	useFetchApplicationDetailsQuery,
	useFetchApplicationStatusQuery,
} from "../services/application";
import { useApplicationId } from "./useApplicationId";
import { useUser } from "./useUser";

export const useApplicationDetails = () => {
	const applicationId = useApplicationId();

	const { getLoggedInUser } = useUser();

	const { data: applicationDetails, isLoading: isApplicationDetailsLoading } =
		useFetchApplicationDetailsQuery(applicationId);

	const { data: applicationStatus } = useFetchApplicationStatusQuery(applicationId);
	const isOrgEf = applicationDetails?.organization.orgType === "ef";

	const currentUserNationalId = getLoggedInUser().bankIdUser.bankIdNumber;

	const isCurrentUserApplicant = currentUserNationalId === applicationDetails?.applicant.nationalId;

	return {
		isOrgEf,
		applicationDetails,
		isApplicationDetailsLoading,
		isCurrentUserApplicant,
		currentUserNationalId,
		applicationStatus,
		isLoading: isApplicationDetailsLoading,
		applicant: applicationDetails?.applicant,
		representatives: applicationDetails?.organization.representatives || [],
	};
};
